// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1018":"4095fe6cfc63eb37","7071":"3cd84d2076f17ead"}[chunkId] + ".css";
};